import BaseService from './baseService';

export default {
  getUsuariosHabilitador() {
    return BaseService.get("usuario/listarUsuariosHabilitador");
  },

};
